define(()=> {
    const defaultStepLabel = (step) => {
        console.error(`No label defined for step ${step.name}`);
        return 'Dummy label';
    };

    return function (step) {
        let _labelFn;

        /**
         * Provide a function to associate a label with a step
         *
         * @params {Function} labelFn - Function to return a translated label for a step,
         *                              The arguments to this function are model along with extraArgs map
         *                              The function should return a string.
         *                              If no function is provided the default behavior is to return 'Dummy label'.
         *
         *
         */
        return function (labelFn) {
            if (arguments.length === 0) {
                return _labelFn ? _labelFn() : defaultStepLabel(step);
            }
            _labelFn = labelFn;

            return step;
        };
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/flow/build/Label.js
 **/